export default function() {
  return [
    {
      path: '/',
      name: '/',
      // redirect: { name: 'Home' },
      // children: []
      component: () => import('@src/views/home-page/index.js')
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@src/views/home-page/index.js')
    },
    {
      path: '/service-capability',
      name: 'ServiceCapability',
      component: () => import('@src/views/service-capability/index.js')
    },
    {
      path: '/solution-yq',
      name: 'SolutionYq',
      component: () => import('@src/views/solution/src/SolutionYq')
    },
    {
      path: '/solution-hy',
      name: 'SolutionHy',
      component: () => import('@src/views/solution/src/SolutionHy')
    },
    {
      path: '/solution-qy',
      name: 'SolutionQy',
      component: () => import('@src/views/solution/src/SolutionQy')
    },
    {
      path: '/solution-yd',
      name: 'SolutionYd',
      component: () => import('@src/views/solution/src/SolutionYd')
    },
    {
      path: '/solution-bs',
      name: 'SolutionBs',
      component: () => import('@src/views/solution/src/SolutionBs')
    },
    {
      path: '/solution-zf',
      name: 'SolutionZf',
      component: () => import('@src/views/solution/src/SolutionZf')
    },
    {
      path: '/app-redirect',
      name: 'AppRedirect',
      component: () => import('@src/AppRedirect'),
      children: [
        {
          path: '/login',
          name: 'Login',
          component: () => import('@src/views/system/login/index.js')
        },
        {
          path: '/reset',
          name: 'Reset',
          component: () => import('@src/views/system/reset/index.js')
        },
        {
          path: '/register',
          name: 'Register',
          component: () => import('@src/views/system/register/index.js')
        },
        //'registration-steps-1'
        {
          path: '/registration/register',
          name: 'RegisterRegister',
          component: () => import('@src/views/registration-steps/register/index.js')
        },
        //'registration-steps-2'
        {
          path: '/registration/supplement',
          name: 'RegisterSupplementInfo',
          component: () => import('@src/views/registration-steps/supplement/index.js')
        },
        //'registration-steps-3'
        {
          path: '/registration/result',
          name: 'RegisterResult',
          component: () => import('@src/views/registration-steps/result/index.js')
        }
      ]
    },
    {
      path: '/developer-document',
      name: 'DeveloperDocument',
      component: () => import('@src/views/developer-document/index.js')
    },
    {
      path: '/developer-guide',
      name: 'DeveloperGuide',
      component: () => import('@src/views/developer-guide/index.js')
    },
    {
      path: '/api-tools',
      name: 'ApiTools',
      component: () => import('@src/views/api-tools/index.js')
    },
    {
      path: '/terms',
      name: 'Terms',
      component: () => import('@src/views/system/terms/index.js')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@src/views/system/privacy/index.js')
    }
  ]
}
